// CCS-388: build the payload for updating a Service User from the profile form.
//
// The form is seeded with the entire fetched user object (react-hook-form
// `reset({...user})`), so the raw form values contain fields this form does not
// edit. Sending them broke the update:
//   - `calls` is a JSONB column; the API bound it as text -> 500 on every save.
//   - `date_of_birth` / `start_date` are sent as "" when the user has no date;
//     the API cannot parse an empty string into a date -> the request failed to
//     deserialize before it even ran.
//   - other server-managed/relational fields (id, timestamps, ids) are not
//     editable here and must not be written back.
//
// Only the editable personal-information fields are forwarded, and empty date
// strings are omitted (so the stored value is preserved rather than cleared or
// rejected).
export const EDITABLE_SERVICE_USER_FIELDS = [
  "firstName",
  "lastName",
  "ethnicity",
  "gender",
  "address",
  "telephoneNumber",
  "postalCode",
  "emailAddress",
  "nfcTag",
  "pharmacy",
  "gpPractice",
  "gpContractNumber",
  "nextOfKin",
  "nextOfKinContactNumber",
];

export const buildServiceUserUpdatePayload = (values = {}) => {
  const payload = {};

  for (const key of EDITABLE_SERVICE_USER_FIELDS) {
    if (values[key] !== undefined) {
      payload[key] = values[key];
    }
  }

  // Dates: only send a non-empty value. An empty string can't be parsed by the
  // API; omitting it leaves the stored date untouched.
  const dob = values.dateOfBirth;
  if (typeof dob === "string" ? dob.trim() !== "" : Boolean(dob)) {
    payload.dateOfBirth = dob;
  }
  const start = values.startDate;
  if (typeof start === "string" ? start.trim() !== "" : Boolean(start)) {
    payload.startDate = start;
  }

  return payload;
};
